export const bookingBackgroundGifUrl =
	process.env.REACT_APP_BOOKING_BACKGROUND_GIF || "/Adobe Express - My Haircut.gif";
export const calComBookingUrl = "https://cal.com/emmansa00/haircut";
